import { apiClient } from "../../../lib/apiClient";
import type { ActivityPage } from "./types";

/**
 * Fetch one page of the project activity feed.
 *
 * @param projectId Project UUID (path param).
 * @param cursor Opaque cursor from a prior call; null/omit for the first page.
 * @param limit Page size, 1–50. Defaults to 10 on the server.
 * @param actions Restrict the page to these action strings — sent as a
 *   repeated `action` param. Omit for the whole feed. The server rejects an
 *   action it doesn't know with `invalid_action`, so pass the canonical
 *   strings from internal/admin/activity/actions.go.
 */
export async function fetchActivity(
  projectId: string,
  cursor: string | null,
  limit = 10,
  actions?: string[],
): Promise<ActivityPage> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  for (const action of actions ?? []) params.append("action", action);
  const r = await apiClient.get<ActivityPage>(
    `/api/admin/projects/${projectId}/activity?${params.toString()}`,
  );
  return r.data;
}
